/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HeartIcon16Solid = forwardRef('HeartIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1.002 5.868C1.002 3.732 2.61 2 4.75 2 6.01 2 7.5 2.752 8 4.25 8.5 2.752 9.99 2 11.25 2c2.14 0 3.748 1.732 3.748 3.868 0 2.457-2.104 4.122-3.731 5.672-.597.569-1.273 1.212-2.029 1.955a1.77 1.77 0 0 1-2.476 0c-.756-.743-1.432-1.386-2.029-1.955-1.627-1.55-3.731-3.215-3.731-5.672Z" })));
});
